<template>
  <sea-page class="mt-3" title="Dati azienda" back showCompanyHeader>
    <sea-page-content toolbar hideRapidSearch>
      <template v-slot:toolbar>
        <v-btn
          label="Aggiorna dati azienda"
          fab
          dark
          x-small
          @click="save()"
          class="ma-2"
          :color="colors.primarycolor"
          :disabled="$v.companyDetails.$invalid"
          ><v-icon >mdi-content-save</v-icon></v-btn
        >
      </template>
      <form name="form" role="form">
        <v-row class="mt-5" no>
          <v-col  cols="12" md="6">
            <p  class="text-caption text-formatter"><b>Dati azienda</b></p>
            <v-row no-gutters>
              <v-col cols="6">
                <v-text-field
                  class="text-caption"
                  label="Ragione sociale"
                  :value="companyDetails.ragioneSociale"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  class="text-caption"
                  label="Nome"
                  :value="companyDetails.nome"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  class="text-caption"
                  label="Codice Fiscale"
                  v-model="companyDetails.codiceFiscale"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  class="text-caption"
                  label="Partita IVA"
                  v-model="companyDetails.partitaIva"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6"></v-col>
          <v-col cols="12" md="6">
            <p class="text-caption text-formatter">
              <b>Sede legale/residenza</b>
            </p>
            <v-text-field
              class="text-caption"
              label="Indirizzo"
              :value="companyDetails.sLegIndirizzo"
              disabled
            ></v-text-field>
            <v-row no-gutters>
              <v-col cols="7">
                <v-text-field
                  class="text-caption"
                  label="Comune"
                  :value="companyDetails.sLegComune"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  class="text-caption"
                  label="CAP"
                  :value="companyDetails.sLegCap"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  class="text-caption"
                  label="Provincia"
                  :value="companyDetails.sLegPr"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="3">
                <v-text-field
                  class="text-caption"
                  label="Prefisso"
                  :value="companyDetails.sLegTelPref"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  class="text-caption"
                  label="Telefono"
                  :value="companyDetails.sLegTelefono"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  class="text-caption"
                  label="Mobile"
                  v-model="companyDetails.sLegCellulare"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
              class="text-caption"
              label="Email"
              :value="companyDetails.email"
              disabled
            ></v-text-field>
            <v-text-field
              class="text-caption"
              label="Email PEC*"
              v-model="companyDetails.sLegPec"
              @input="$v.editedItem.sLegPec.$touch()"
              @blur="$v.editedItem.sLegPec.$touch()"
              :error-messages="errors('sLegPec')"
              required
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
            v-for="(item, index) in companyDetails.sediOperative"
            :key="item.id"
          >
            <p class="text-caption text-formatter">
              <b>Sede Operativa {{ index + 1 }}</b>
            </p>
            <v-text-field
              class="text-caption"
              label="Descrizione"
              v-model="item.descrizione"
            ></v-text-field>
            <v-text-field
              class="text-caption"
              label="Indirizzo"
              v-model="item.indirizzo"
            ></v-text-field>
            <v-row no-gutters>
              <v-col cols="7">
                <v-text-field
                  class="text-caption"
                  label="Comune"
                  v-model="item.comune"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  class="text-caption"
                  label="CAP"
                  v-model="item.cap"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  class="text-caption"
                  label="Provincia"
                  v-model="item.pr"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="3">
                <v-text-field
                  class="text-caption"
                  label="Prefisso"
                  v-model="item.telPref"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  class="text-caption"
                  label="Telefono"
                  v-model="item.telefono"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  class="text-caption"
                  label="Mobile"
                  v-model="item.cellulare"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
              class="text-caption"
              label="Email"
              v-model="item.email"
            ></v-text-field>
          </v-col>
        </v-row>
      </form>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import mixin from "@/mixin";

export default {
  name: "company",
  mixins: [mixin, validationMixin],
  validations: {
    companyDetails: {
      sLegPec: { required },
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.idCompany = to.params.id;
    });
  },
  mounted() {
    this.fetchCompanyDetails(this.idCompany);
    this.fetchName(this.idCompany);
  },
  methods: {
    ...mapActions({
      fetchCompanyDetails: "widget/fetchCompanyDetails",
      fetchName: "widget/fetchName",
      updateCompanyDetails: "widget/updateCompanyDetails",
    }),
    errors(fieldName) {
      const errors = [];
      if (this.companyDetails[fieldName]) return errors;
      if (fieldName === "sLegPec") {
        errors.push(this.locales.required);
      }
      return errors;
    },
    save() {
      this.$v.$touch();

      if (!this.$v.companyDetails.$invalid) {
        this.updateCompanyDetails();
        this.$router.push("/company/home");
      }
    },
  },
  computed: {
    ...mapGetters({
      companyDetails: "widget/companyDetails",
      currentCompany: "widget/currentCompany",
      companyName: "widget/companyName",
    }),
  },
};
</script>
<style>

</style>